<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import ReportGenerateDialogHeader from '@/components/headers/ReportGenerateDialogHeader.vue';
import PageDialogWrapper from '@/components/wrappers/PageDialogWrapper.vue';

export interface Props {
  isConfirmLoading?: boolean;
  stopNumber?: number;
  confirm?: () => Promise<unknown>;
}
export type DefProps = typeof props;

const props = withDefaults(defineProps<Props>(), {
  isConfirmLoading: false,
  stopNumber: undefined,
  confirm: undefined,
});

const emit = defineEmits<{
  cancelBtnClick: [event: Event];
  confirmBtnClick: [event: Event, props: DefProps];
}>();

function handleCancelClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('cancelBtnClick', event);
}

function handleConfirmClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('confirmBtnClick', event, props);
}
</script>

<template>
  <PageDialogWrapper
    :class="$style.jobEditDeleteStopDialog"
    data-testid="jobEditDeleteStopDialog"
  >
    <template #header>
      <ReportGenerateDialogHeader @close-click="handleCancelClick">
        Delete Stop {{ props.stopNumber }}
      </ReportGenerateDialogHeader>
    </template>

    <section>
      <div :class="$style.text">
        If you want to delete stop {{ props.stopNumber }}, press the button to
        confirm your action.
      </div>
    </section>

    <template #footer>
      <menu :class="$style.dialogFooterMenuList">
        <li :class="$style.dialogFooterMenuListItem">
          <KBtn
            variant="outlined"
            append-icon="mdi-close"
            :disabled="props.isConfirmLoading"
            @click="handleCancelClick"
          >
            Cancel
          </KBtn>
        </li>
        <li :class="$style.dialogFooterMenuListItem">
          <KBtn
            append-icon="mdi-delete"
            :loading="props.isConfirmLoading"
            @click="handleConfirmClick"
          >
            Delete
          </KBtn>
        </li>
      </menu>
    </template>
  </PageDialogWrapper>
</template>

<style module lang="scss">
@use 'sass:math';
@use '@/styles/colors';
@use '@/styles/variables';

.jobEditDeleteStopDialog {
  width: variables.$reportGenerateDialogWidth;
}
.text {
  margin: 0 0 math.div(variables.$pageDialogWindowMainWrapperMargin, 2) 0;
}
.dialogFooterMenuList {
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: right;
}
.dialogFooterMenuListItem {
  display: inline;
}
.dialogFooterMenuListItem + .dialogFooterMenuListItem {
  margin-left: 1rem;
}
</style>
